var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-menu",class:_vm.rootClasses},[_c('div',{staticClass:"main-menu__bar",style:(_vm.scrollLockStyles)},[_c('div',{staticClass:"main-menu__burger"},[_c('navigation-btn',{staticClass:"main-menu__btn",attrs:{"is-active":_vm.isOpen},on:{"click":_vm.onClick}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }